var map = {
	"./ar": [
		"7e82",
		"lang-ar"
	],
	"./ar.js": [
		"7e82",
		"lang-ar"
	],
	"./en": [
		"3fab"
	],
	"./en.js": [
		"3fab"
	],
	"./id": [
		"fcd3",
		"lang-id"
	],
	"./id.js": [
		"fcd3",
		"lang-id"
	],
	"./km": [
		"c309",
		"lang-km"
	],
	"./km.js": [
		"c309",
		"lang-km"
	],
	"./messages": [
		"3b9f"
	],
	"./messages.js": [
		"3b9f"
	],
	"./ms": [
		"c18c",
		"lang-ms"
	],
	"./ms.js": [
		"c18c",
		"lang-ms"
	],
	"./ta": [
		"412f",
		"lang-ta"
	],
	"./ta.js": [
		"412f",
		"lang-ta"
	],
	"./th": [
		"46e9",
		"lang-th"
	],
	"./th.js": [
		"46e9",
		"lang-th"
	],
	"./zh": [
		"9df6",
		"lang-zh"
	],
	"./zh.js": [
		"9df6",
		"lang-zh"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5892";
module.exports = webpackAsyncContext;